/* 🤖 this file was generated by svg-to-ts */
export const siriusArrowRight: {
  name: 'arrow_right';
  data: string;
} = {
  name: 'arrow_right',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" style="display: block;"><path d="M14.03 4.72a.75.75 0 1 0-1.06 1.06l5.47 5.47H3.75a.75.75 0 0 0 0 1.5h14.69l-5.47 5.47a.75.75 0 1 0 1.06 1.06l6.75-6.75a.747.747 0 0 0 0-1.06l-6.75-6.75Z" fill="currentColor"/></svg>`
};
